import "../../chunk-5WRI5ZAA.js";

// src/visualBuilder/generators/generateAddInstanceButtons.tsx
import { render } from "preact";
import AddInstanceButtonComponent from "../components/addInstanceButton.js";
import { jsx } from "preact/jsx-runtime";
function generateAddInstanceButton(_ref) {
  let {
    value,
    fieldSchema,
    fieldMetadata,
    index,
    loading,
    onClick,
    label
  } = _ref;
  const wrapper = document.createDocumentFragment();
  render(/* @__PURE__ */jsx(AddInstanceButtonComponent, {
    loading,
    index,
    value,
    label,
    onClick,
    fieldSchema,
    fieldMetadata
  }), wrapper);
  const button = wrapper.children[0];
  return button;
}
function getAddInstanceButtons(visualBuilderContainer) {
  let getAllButtons = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const buttons = visualBuilderContainer.getElementsByClassName("visual-builder__add-button");
  if (getAllButtons) {
    return Array.from(buttons);
  }
  if (buttons.length < 2) {
    return null;
  }
  const previousButton = buttons[0];
  const nextButton = buttons[1];
  return [previousButton, nextButton];
}
export { generateAddInstanceButton, getAddInstanceButtons };